import { Phase } from '@/types/phase';
import { OptionType } from '@/ui/components/Form/Select/types';

export enum TimeUnitLabel {
  DAY = 'day',
  WEEK = 'week',
  YEAR = 'year'
}

export type Props = {
  initialAppointmentTypeId?: string;
  onCancel: VoidFunction;
  onSuccess?: (appointmentTypeId: string) => void;
  phase: Phase;
  timeZone: string;
};

export interface CustomScheduleExpectationFormValues {
  appointment_type: OptionType<string>;
  cycle_time: string;
  frequency: string;
  look_ahead_cycles: OptionType<string>;
  max_attendances: string | null;
  note: string | null;
  phase: string;
  start_at: string;
  time_unit: string;
}

export interface CustomScheduleExpectationFormPayload extends Omit<
  CustomScheduleExpectationFormValues,
  'appointment_type' | 'look_ahead_cycles' | 'max_attendances' | 'start_at' | 'time_unit'
> {
  appointment_type: string;
  look_ahead_cycles: string;
  max_attendances: number | null;
  note: string | null;
  start_at: string;
  time_unit: string;
}
